import { Component, input, InputSignal, signal, WritableSignal } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { CmsQueryList, CmsTaxonomy } from '@fcom/core-api';
import { TagTheme } from '@fcom/ui-components';

import { getFontLevel, getHeaderLevel } from '../../services/cms-utils/cms-utils';

@Component({
  selector: 'cms-cmrelated',
  templateUrl: './cms-cmrelated.component.html',
  styleUrl: './cms-cmrelated.component.scss',
  standalone: false,
})
export class CmsCmrelatedComponent {
  readonly DEFAULT_HEADER_LEVEL = 3;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TagTheme = TagTheme;

  chipsOnly: InputSignal<boolean> = input<boolean>(false);
  content: InputSignal<CmsQueryList> = input<CmsQueryList>();
  filter: WritableSignal<string | null> = signal(null);
  templateTags: InputSignal<CmsTaxonomy[]> = input<CmsTaxonomy[]>();

  filterValue(value: string): void {
    this.filter.set(value);
  }

  headerLevel(tags: CmsTaxonomy[]): number {
    return getHeaderLevel(tags);
  }

  headerFontLevel(tags: CmsTaxonomy[]): string {
    return getFontLevel(tags);
  }
}
